export default __webpack_public_path__ + "static/media/phylactere_maman_NL.d8b84d8a.png";